export default class SyncImages extends HTMLElement {
  private images: HTMLImageElement[] = [];

  constructor() {
    super();
  }

  connectedCallback() {
    this.images = Array.from(this.querySelectorAll('img[data-src]'));
    
    if (this.images.length === 0) {
      this.classList.add('is-loaded');
      return;
    }

    this.loadImages();
  }

  private loadImages() {
    const promises = this.images.map((img) => {
      return new Promise<void>((resolve) => {
        const src = img.getAttribute('data-src');
        if (!src) {
          resolve();
          return;
        }

        const tempImg = new Image();
        
        const onComplete = () => {
          resolve();
        };

        tempImg.onload = onComplete;
        tempImg.onerror = onComplete;
        tempImg.src = src;
      });
    });

    // Wait for ALL images to load in memory first
    Promise.all(promises).then(() => {
      // Update all src attributes synchronously in a single batch
      // Using requestAnimationFrame ensures they're all set in the same frame
      requestAnimationFrame(() => {
        this.images.forEach((img) => {
          const src = img.getAttribute('data-src');
          if (src) {
            img.src = src;
            img.removeAttribute('data-src');
          }
        });
        
        // Wait one more frame to ensure all images are painted, then reveal
        requestAnimationFrame(() => {
          this.classList.add('is-loaded');
        });
      });
    });
  }
}
